export const DIMENSIONS = { width: 530, height: 455 }

export const HELP_ID = '2b696841-4775-4a44-b6a5-953fe6c1d3e4'

export const NEW_DYNAMIC_PAGE_INTRO_PANEL_ACTIONS = {
  OPEN_PRESETS_MODAL: 'OPEN_PRESETS_MODAL',
  OPEN_CREATE_COLLECTION_PANEL: 'OPEN_CREATE_COLLECTION_PANEL',
}

export const EMPTY_STATE_IMAGE_URL = './assets/empty_state.png'
